import { useEffect, useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { serviceProviderUpdate, serviceProviderDetails, logOutApi } from '../../../Context/api';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { editServiceProviderValidation, serviceProviderValidation } from '../../../Context/validation';
import { useNavigate, useParams } from 'react-router-dom';
import { isValidPhoneNumber } from 'react-phone-number-input';

const UseEditProvider = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const { id } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        serviceProviderView()
        setSpinner(true)
    }, [])


    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const serviceProviderView = () => {
        axios.post(serviceProviderDetails(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                // editServiceProvider.setValues(resp.data.data)
                // editServiceProvider.setValues(resp.data.data.location)
                editServiceProvider.setFieldValue('businessName', resp.data.data.business.name)
                editServiceProvider.setFieldValue('category', resp.data.data.business.category)
                editServiceProvider.setFieldValue('email', resp.data.data.email)
                editServiceProvider.setFieldValue('name', resp.data.data.name)
                editServiceProvider.setFieldValue('mobileNo', resp.data.data.mobileNo)
                editServiceProvider.setFieldValue('about', resp.data.data.about)
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    const editServiceProvider = useFormik({
        initialValues: {
            name: '',
            businessName: '',
            category: '',
            about: '',
            mobileNo: '',
            email: '',
        },
        validationSchema: editServiceProviderValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                userId: id,
                name: values.name.trim(),
                businessName: values.businessName.trim(),
                createdbyId: id,
                about: values.about.trim(),
                mobileNo: `${values.mobileNo}`,
                email: values.email.trim(),
                category: values.category.trim(),
                image: '',
                // allpermissions:permissions
            }
            // console.log(data,'dataaaaaaaaaaaa')
            // return
            setSpinner(true)
            axios.post(serviceProviderUpdate(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    navigate(-1)
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })

        }

    })
    // console.log(editServiceProvider.values,'editServiceProvider')
    return {
        spinner,
        editServiceProvider,
    }
}

export default UseEditProvider